import React, { useState } from 'react';
import s from './ReturnStatus.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import useGetOrderItemsByOrderId from 'sdk/hooks/shop/useGetOrderItemsByOrderId';
import useGetTransactionByIdAnyStatus from 'sdk/hooks/shop/useGetTransactionByIdAnyStatus';
import ProfileMenuHeader from '../ProfileMenu/ProfileMenuHeader';
import Status from './Status';
import useGetOrders from 'modules/product/pages/OrderDetails/api';

const formatDate = dateString => {
  const date = new Date(dateString);
  return date?.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

const ReturnStatus = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: orderItems } = useGetOrderItemsByOrderId(id);
  const { data: transaction } = useGetTransactionByIdAnyStatus(orderItems?.orders?.transaction_id);

  const [orderHistory, setOrderHistory] = useState([]);

  const fetchOrderHistory = async orderIds => {
    try {
      const req = await fetch(
        'https://gibnkggiuxphkienkxwf.supabase.co/functions/v1/get-oto-order-history',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdpYm5rZ2dpdXhwaGtpZW5reHdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA3OTI0OTEsImV4cCI6MjA0NjM2ODQ5MX0.jzHj8vjuo7KuX4nHi-_tq051mp9quUNKMP0wN8Makj4`, // Замените YOUR_ACCESS_TOKEN на ваш токен
          },
          body: JSON.stringify({ id: orderIds }),
        },
      );

      const data = await req.json();

      setOrderHistory(data?.items?.[0]?.history);
    } catch (error) {
      console.error('Error fetching order history:', error);
    }
  };

  React.useEffect(() => {
    if (orderItems && orderItems?.order_id) {
      fetchOrderHistory(orderItems?.order_id);
    }
  }, [transaction]);

  return (
    <div className={s.return_status}>
      <ProfileMenuHeader text={'Return status'} onClose={() => navigate(-1)} />
      <div className={s.card}>
        <div
          className={s.card__header}
          onClick={() => navigate(`/product/${orderItems?.product?.id}`)}
        >
          <img
            src={orderItems?.product?.image}
            className={s.card__header_image}
            alt={orderItems?.product?.name}
          />
          <div className={s.card__header_info}>
            <div>
              <div className={s.card__header_info_name}>{orderItems?.product?.name}</div>
              <div className={s.card__header_info_description}>
                {orderItems?.product?.description}
              </div>
            </div>
            <div className={s.card__header_info_bottom}>
              <div className={s.card__header_info_bottom_price}>${orderItems?.product?.price}</div>
              <div className={s.card__header_info_bottom_status}>{orderItems?.orders?.status}</div>
            </div>
          </div>
        </div>
        <div className={s.card__body}>
          <div className={s.card__body_item}>
            Order #: <span>{orderItems?.order_id}</span>
          </div>
          <div className={s.card__body_item}>
            Product: <span>{orderItems?.product?.name}</span>
          </div>
          <div className={s.card__body_item}>
            Purchased on: <span>{formatDate(orderItems?.created_at)}</span>
          </div>
        </div>
        <div className={s.card__body}>
          <div className={s.card__body_item}>
            Current status: <span>{orderItems?.orders?.status}</span>
          </div>
          <div className={s.card__body_item}>
            Last updated: <span>{formatDate(transaction?.updated_at)}</span>
          </div>
        </div>
        <div className={s.card__body}>
          <div className={s.card__body_item}>
            Reason for return: <span>{transaction?.cancellation_reason}</span>
          </div>
        </div>
        <div className={s.card__body}>
          <div className={s.card__body_item}>
            {orderHistory?.map(item => {
              return (
                <Status
                  //@ts-ignore
                  date={item?.date}
                  //@ts-ignore
                  status={item?.status}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnStatus;
